'use client';
import { jsx } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var a, r, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)a = n[r], !(t.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (o[a] = e[a]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var a, r, o = {}, n = Object.keys(e);
    for(r = 0; r < n.length; r++)a = n[r], t.indexOf(a) >= 0 || (o[a] = e[a]);
    return o;
}
const Callout = renderWithRef('Callout', null, (a, o)=>{
    let { skin: n = 'info', border: s = 'standard', variant: i = 'standard', emphasis: d = 'standard', size: l = 'standard', children: c } = a, p = _object_without_properties(a, [
        "skin",
        "border",
        "variant",
        "emphasis",
        "size",
        "children"
    ]);
    useDeprecatedProps('Callout', a, [
        {
            propName: 'border',
            instructions: 'This is deprecated without a replacement.'
        },
        {
            propName: 'variant',
            deprecatedValues: {
                standard: 'This is deprecated without a replacement.',
                overlay: 'Use emphasis="low" instead.',
                inverse: 'This is deprecated without a replacement.'
            }
        },
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        },
        {
            propName: 'skin',
            deprecatedValues: {
                discount: 'Use skin="promo" instead.',
                standard: 'Use skin="info" instead.',
                foil: 'This is deprecated without a replacement.',
                new: 'Use skin="accent" instead.',
                announcement: 'Use skin="accent" instead.',
                holiday: 'This is deprecated without a replacement.'
            }
        }
    ]);
    let u = new Set([
        'swan-callout'
    ]);
    return 'standard' !== n && 'info' !== n && u.add(`swan-callout-skin-${n}`), 'none' === s && u.add('swan-callout-borderless'), 'overlay' === i && u.add('swan-callout-overlay'), 'inverse' === i && u.add('swan-callout-inverse'), 'low' === d && u.add('swan-callout-emphasis-low'), 'mini' === l && u.add('swan-callout-mini'), jsx(RenderComp, {
        root: "span",
        forwardedRef: o,
        classNames: u,
        props: p,
        children: c
    });
});

export { Callout };
